import { ProjectAttachmentService as OvermapProjectAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProjectAttachmentService extends OvermapProjectAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
